module.exports = __webpack_public_path__ + "static/icons/icon-chevron-circle-right--white-9440485a3edf0185ae505718e2ffc797.svg";